import React from "react";
import { Box, LinearProgress, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

// Custom styled LinearProgress with dynamic colors
const StyledLinearProgress = styled(LinearProgress)(({ theme, fillpercentage }) => {
  // Determine color based on fill percentage
  let barColor;
  if (fillpercentage >= 75) {
    barColor = "#795548"; // Brand brown - full/serious
  } else if (fillpercentage >= 50) {
    barColor = "#e95601"; // Warm orange - getting full
  } else if (fillpercentage >= 25) {
    barColor = "#d8a746"; // Brand gold - moderate
  } else {
    barColor = "#5bbd2a"; // Fresh green - plenty of space
  }

  return {
    height: 8,
    borderRadius: 4,
    backgroundColor: "#e0e0e0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: barColor,
      transition: "all 0.3s ease",
    },
  };
});

const BatteryIndicator = ({ currentPeople, maxPeople }) => {
  // Calculate fill percentage
  const calculatePercentage = () => {
    if (maxPeople === 0) return 0;
    return Math.min((currentPeople / maxPeople) * 100, 100);
  };

  const percentage = calculatePercentage();

  // Tooltip text for accessibility
  const getTooltipText = () => {
    if (currentPeople === 0) return "Dużo wolnych miejsc";

    const fillPercent = percentage;
    if (fillPercent >= 100) return "Pełne";
    if (fillPercent >= 75) return "Prawie pełne";
    if (fillPercent >= 50) return "Średnie zapełnienie";
    if (fillPercent >= 25) return "Sporo miejsc";
    return "Dużo wolnych miejsc";
  };

  return (
    <Tooltip title={getTooltipText()} arrow placement="top">
      <Box sx={{ width: "100%", maxWidth: 60, display: "inline-block" }}>
        <StyledLinearProgress
          variant="determinate"
          value={percentage}
          fillpercentage={percentage}
        />
      </Box>
    </Tooltip>
  );
};

export default BatteryIndicator;
